import MatchStatistic from '../../../interfaces/matchStatistic';

export default function getStatsCountForType(
  matchStatistics: Array<MatchStatistic>,
  teamId: number,
  matchStatisticsTypeId: number,
): number | null {
  for (const matchStatistic of matchStatistics) {
    if (matchStatistic.teamId === teamId && matchStatistic.matchStatisticsTypeId === matchStatisticsTypeId) {
      return matchStatistic.statisticsCount;
    }
  }
  return null;
}
